module.exports = __webpack_public_path__ + "img/device_icon_title_red.b83ae45a.svg";